// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle_subtitle__ULv9W","metadataText":"Subtitle_metadataText__7cTed"};